import type { AdditionalResource } from '../types/additionalResource';
import type { CustomizationType } from '../types/customizationTypes';
import type { AudioFeatureType } from '../types/audioFeatureType';

type getSharedAttributesProps = {
	customization?: CustomizationType;
	additionalResources?: AdditionalResource[];
	playbackSpeed: number;
	hasFetched: boolean;
	activeFeature: AudioFeatureType | undefined;
};

export const getSharedAttributes = ({
	customization,
	additionalResources,
	playbackSpeed,
	hasFetched,
	activeFeature,
}: getSharedAttributesProps) => {
	return {
		tone: customization?.tone,
		length: customization?.length,
		sourceCount: additionalResources?.length,
		playbackSpeed,
		hasFetched,
		feature: activeFeature,
	};
};
